import { apiCguCreateUsuario, apiCguGetPerfiles, apiCguGetUsuarios } from "../settings/apiConfig";
import { createContext, useContext, useState } from "react";
import { fnHandleChangeChek, fnHandleChangeDate, fnHandleChangeText } from "../settings/handleConfig";
import { fnPrevent, fnPreventBlur } from "../settings/preventConfig";
import { getFormUsuario, getModelUsuario } from "../models/UsuarioModel";

import { EnumPerfilesPrincipales } from "../settings/enumConfig";
import { rxCorreo } from "../settings/regexConfig";
import { useLayout } from "./LayoutContext";
import { useLogin } from "./LoginContext";
import { useRequest } from "./RequestContext";

export const UsuarioContext = createContext();

export function UsuarioProvider(props) {
    const { handleOpenAlert } = useLayout();
    const { usuarioSesion } = useLogin();
    const { Get, Post } = useRequest();

    const [listaUsuarios, setListaUsuarios] = useState([]);
    const [listaPerfiles, setListaPerfiles] = useState([]);
    const [usuarioSeleccionado, setUsuarioSeleccionado] = useState(getModelUsuario());
    const [modalOpenFormUsuario, setModalOpenFormUsuario] = useState(false);
    const [modalOpenDetalleUsuario, setModalOpenDetalleUsuario] = useState(false);
    const [modalOpenEliminarUsuario, setModalOpenEliminarUsuario] = useState(false);
    const [formUsuario, setFormUsuario] = useState(getFormUsuario());
    const [mostrarPassword, setMostrarPassword] = useState(false);

    const handleChangeListaUsuarios = (value) => {
        setListaUsuarios(value);
    };

    const handleChangeUsuarioSeleccionado = (value) => {
        setUsuarioSeleccionado(value);
    };

    const handleChangeMostrarPassword = (value) => {
        setMostrarPassword(value);
    };

    const handleOpenFormUsuario = (value) => {
        setModalOpenFormUsuario(value);
    };

    const handleOpenDetalleUsuario = (value) => {
        setModalOpenDetalleUsuario(value);
    };

    const handleOpenEliminarUsuario = (value) => {
        setModalOpenEliminarUsuario(value);
    };

    const handleChangeFormText = fnHandleChangeText(formUsuario, setFormUsuario);
    const handleChangeFormDate = fnHandleChangeDate(formUsuario, setFormUsuario);
    const handleChangeFormCheck = fnHandleChangeChek(formUsuario, setFormUsuario);

    const handleClickNuevoUsuario = () => {
        const usuario = getModelUsuario();
        setUsuarioSeleccionado(usuario);
        fnFillFormUsuario(usuario);
        setModalOpenFormUsuario(true);
    };

    const handleClickEditarUsuario = () => {
        if (usuarioSeleccionado.iIdUsuario === 0) {
            handleOpenAlert("Seleccione un usuario para editar");
            return;
        }
        if (
            usuarioSeleccionado.iIdPerfil === EnumPerfilesPrincipales.DoctorCallCenter ||
            usuarioSeleccionado.iIdPerfil === EnumPerfilesPrincipales.DoctorEspecialista ||
            usuarioSeleccionado.iIdPerfil === EnumPerfilesPrincipales.AdministradorEspecialiesta
        ) {
            handleOpenAlert(
                "Los usuarios con cuenta de colaborador o doctor solo se pueden editar en la sección de Colaboradores del menú Administración",
                "warning"
            );
            return;
        }
        fnFillFormUsuario(usuarioSeleccionado);
        setModalOpenFormUsuario(true);
    };

    const handleClickDetalleUsuario = () => {
        if (usuarioSeleccionado.iIdUsuario === 0) {
            handleOpenAlert("Seleccione un usuario para ver el detalle");
            return;
        }
        setModalOpenDetalleUsuario(true);
    };

    const handleClickEliminarUsuario = () => {
        if (usuarioSeleccionado.iIdUsuario === 0) {
            handleOpenAlert("Seleccione un usuario para eliminar");
            return;
        }
        if (usuarioSeleccionado.iIdUsuario === 1) {
            handleOpenAlert("El usuario principal del sistema no se puede eliminar", "warning");
            return;
        }
        if (
            usuarioSeleccionado.iIdPerfil === EnumPerfilesPrincipales.DoctorCallCenter ||
            usuarioSeleccionado.iIdPerfil === EnumPerfilesPrincipales.DoctorEspecialista ||
            usuarioSeleccionado.iIdPerfil === EnumPerfilesPrincipales.AdministradorEspecialiesta
        ) {
            handleOpenAlert(
                "Los usuarios con cuenta de colaborador o doctor solo se pueden eliminar en la sección de Colaboradores del menú Administración",
                "warning"
            );
            return;
        }
        setModalOpenEliminarUsuario(true);
    };

    const handleClickRefrescarDatos = async () => {
        await fnObtenerPerfiles();
        await fnObtenerUsuarios();
    };

    const handleSubmitFormUsuario = (e) => {
        fnPrevent(e);

        const {
            txtNombres,
            txtApellidoPaterno,
            txtApellidoMaterno,
            txtPerfil,
            txtTipoCuenta,
            txtFechaNacimiento,
            txtTelefono,
            txtCorreoElectronico,
            txtDomicilio,
            txtUsuario,
            txtPassword,
            txtAcceso,
        } = formUsuario;
        const telefono = txtTelefono.value.replace(/ /g, "");

        const form = {
            ...formUsuario,
            txtNombres: { ...txtNombres, error: txtNombres.value === "" },
            txtApellidoPaterno: { ...txtApellidoPaterno, error: txtApellidoPaterno.value === "" },
            txtApellidoMaterno: { ...txtApellidoMaterno, error: txtApellidoMaterno.value === "" },
            txtPerfil: { ...txtPerfil, error: txtPerfil.value === "" || parseInt(txtPerfil.value) < 1 },
            txtTipoCuenta: { ...txtTipoCuenta, error: txtTipoCuenta.value === "" && parseInt(txtTipoCuenta.value) > 0 },
            txtFechaNacimiento: { ...txtFechaNacimiento, error: !txtFechaNacimiento.value },
            txtTelefono: { ...txtTelefono, error: telefono === "" || telefono.length !== 10 },
            txtCorreoElectronico: {
                ...txtCorreoElectronico,
                error: txtCorreoElectronico.value === "" || !rxCorreo.test(txtCorreoElectronico.value),
            },
            txtDomicilio: { ...txtDomicilio, error: txtDomicilio.value === "" },
            txtUsuario: { ...txtUsuario, error: txtUsuario.value === "" },
            txtPassword: { ...txtPassword, error: txtPassword.value === "" && usuarioSeleccionado.iIdUsuario === 0 },
        };

        setFormUsuario(form);
        if (
            Object.values(form)
                .map((x) => x.error)
                .includes(true)
        ) {
            return;
        }

        const entUsuario = {
            iIdUsuario: usuarioSeleccionado.iIdUsuario,
            iIdTipoCuenta: usuarioSeleccionado.iIdTipoCuenta,
            iIdPerfil: parseInt(txtPerfil.value),
            sTipoCuenta: usuarioSeleccionado.sTipoCuenta,
            sPerfil: usuarioSeleccionado.sPerfil,
            sUsuario: txtUsuario.value,
            sPassword: txtPassword.value === "" ? null : txtPassword.value,
            sNombres: txtNombres.value,
            sApellidoPaterno: txtApellidoPaterno.value,
            sApellidoMaterno: txtApellidoMaterno.value === "" ? null : txtApellidoMaterno.value,
            dtFechaNacimiento: txtFechaNacimiento.value.toLocaleDateString(),
            sTelefono: txtTelefono.value,
            sCorreo: txtCorreoElectronico.value,
            sDomicilio: txtDomicilio.value === "" ? null : txtDomicilio.value,
            iIdUsuarioMod: usuarioSesion.iIdUsuario,
            bAcceso: txtAcceso.value,
            bActivo: true,
            bBaja: false,
        };
        fnGuardarUsuario(entUsuario);
    };

    const handleSubmitEliminarUsuario = () => {
        const entUsuario = {
            iIdUsuario: usuarioSeleccionado.iIdUsuario,
            iIdTipoCuenta: usuarioSeleccionado.iIdTipoCuenta,
            iIdUsuarioMod: usuarioSesion.iIdUsuario,
            bActivo: false,
            bBaja: true,
        };
        fnEliminarUsuario(entUsuario);
    };

    const fnFillFormUsuario = (usuario) => {
        const model = getFormUsuario();
        const {
            txtNombres,
            txtApellidoPaterno,
            txtApellidoMaterno,
            txtPerfil,
            txtTipoCuenta,
            txtFechaNacimiento,
            txtTelefono,
            txtCorreoElectronico,
            txtDomicilio,
            txtUsuario,
            txtAcceso,
        } = model;

        setFormUsuario({
            ...model,
            txtNombres: { ...txtNombres, value: !usuario.sNombres ? "" : usuario.sNombres },
            txtApellidoPaterno: {
                ...txtApellidoPaterno,
                value: !usuario.sApellidoPaterno ? "" : usuario.sApellidoPaterno,
            },
            txtApellidoMaterno: {
                ...txtApellidoMaterno,
                value: !usuario.sApellidoMaterno ? "" : usuario.sApellidoMaterno,
            },
            txtPerfil: {
                ...txtPerfil,
                value: !usuario.iIdPerfil ? "" : usuario.iIdPerfil === 0 ? "" : usuario.iIdPerfil,
            },
            txtTipoCuenta: {
                ...txtTipoCuenta,
                value: !usuario.iIdTipoCuenta ? "" : usuario.iIdTipoCuenta,
            },
            txtFechaNacimiento: {
                ...txtFechaNacimiento,
                value: !usuario.dtFechaNacimiento ? null : new Date(usuario.dtFechaNacimiento),
            },
            txtTelefono: {
                ...txtTelefono,
                value: !usuario.sTelefono ? "" : usuario.sTelefono,
            },
            txtCorreoElectronico: {
                ...txtCorreoElectronico,
                value: !usuario.sCorreo ? "" : usuario.sCorreo,
            },
            txtDomicilio: {
                ...txtDomicilio,
                value: !usuario.sDomicilio ? "" : usuario.sDomicilio,
            },
            txtUsuario: { ...txtUsuario, value: !usuario.sUsuario ? "" : usuario.sUsuario },
            txtPassword: "",
            txtAcceso: { ...txtAcceso, value: !usuario.bAcceso ? false : usuario.bAcceso },
        });
    };

    const fnObtenerUsuarios = async (
        iIdUsuario = null,
        iIdTipoCuenta = null,
        iIdPerfil = null,
        bActivo = true,
        bBaja = false
    ) => {
        const payload = {
            loader: "Consultando usuarios del sistema...",
            url:
                apiCguGetUsuarios +
                "?iIdUsuario=" +
                iIdUsuario +
                "&iIdTipoCuenta=" +
                iIdTipoCuenta +
                "&iIdPerfil=" +
                iIdPerfil +
                "&bActivo=" +
                bActivo +
                "&bBaja=" +
                bBaja,
            alert: false,
        };

        const response = await Get(payload);
        if (response.Code === 0) {
            setListaUsuarios(response.Result);
        }
    };

    const fnObtenerPerfiles = async (iIdPerfil = null, bActivo = true, bBaja = false) => {
        const payload = {
            loader: "Consultando perfiles del sistema...",
            url: apiCguGetPerfiles + "?iIdPerfil=" + iIdPerfil + "&bActivo=" + bActivo + "&bBaja=" + bBaja,
            alert: false,
        };

        const response = await Get(payload);
        if (response.Code === 0) {
            setListaPerfiles(response.Result);
        }
    };

    const fnGuardarUsuario = async (entUsuario) => {
        const payload = {
            loader: "Guardando usuario...",
            url: apiCguCreateUsuario,
            body: entUsuario,
            alert: true,
        };

        const response = await Post(payload);
        if (response.Code === 0) {
            setModalOpenFormUsuario(false);
            setUsuarioSeleccionado(entUsuario);
            await fnObtenerUsuarios();
        }
        fnPreventBlur();
    };

    const fnEliminarUsuario = async (entUsuario) => {
        const payload = {
            loader: "Eliminando usuario...",
            url: apiCguCreateUsuario,
            body: entUsuario,
            alert: true,
        };

        const response = await Post(payload);
        if (response.Code === 0) {
            setModalOpenEliminarUsuario(false);
            setUsuarioSeleccionado(getModelUsuario());
            await fnObtenerUsuarios();
        }
        fnPreventBlur();
    };

    return (
        <UsuarioContext.Provider
            value={{
                listaUsuarios,
                listaPerfiles,
                usuarioSeleccionado,
                modalOpenFormUsuario,
                modalOpenDetalleUsuario,
                modalOpenEliminarUsuario,
                formUsuario,
                mostrarPassword,
                handleOpenFormUsuario,
                handleOpenDetalleUsuario,
                handleOpenEliminarUsuario,
                handleChangeListaUsuarios,
                handleChangeUsuarioSeleccionado,
                handleChangeMostrarPassword,
                handleChangeFormText,
                handleChangeFormDate,
                handleChangeFormCheck,
                handleClickNuevoUsuario,
                handleClickEditarUsuario,
                handleClickDetalleUsuario,
                handleClickEliminarUsuario,
                handleClickRefrescarDatos,
                handleSubmitFormUsuario,
                handleSubmitEliminarUsuario,
            }}
        >
            {props.children}
        </UsuarioContext.Provider>
    );
}

export function useUsuario() {
    return useContext(UsuarioContext);
}
